import {Injectable} from "@angular/core";
import {ApiClient} from "../../tools/api-client";
import {Observable} from "rxjs";
import {AvConduction} from "./ecg/ecg-preanalysis-data/ecg-preanalysis-data.component";

@Injectable()
export class FinishAnalysisService {
  constructor(private readonly apiClient: ApiClient) {
  }

  finishAnalysis(
    measurementId: number,
    analysisReportFile: File,
  ): Observable<any> {
    return this.apiClient.put<any>(
      `/api/measurements/${measurementId}/finish-analysis`,
      createFinishAnalysisRequest(analysisReportFile)
    );
  }

  finishPreAnalysis(request: FinishPreAnalysisRequest): Observable<void> {
    return this.apiClient.put<any>(
      `/api/measurements/${request.measurementId}/finish-pre-analysis`,
      request.ecgData
    );
  }
}

function createFinishAnalysisRequest(analysisReportFile: File): FormData {
  const formData = new FormData();
  formData.append("analysisReportFile", analysisReportFile, analysisReportFile.name);
  return formData;
}

export interface FinishPreAnalysisRequest {
  readonly measurementId: number;
  readonly ecgData: PreanalysisEcgData;
}

export interface PreanalysisEcgData {
  readonly avConductions: AvConduction[];
  readonly pq: PqData | undefined;
  readonly pq2: PqData | undefined;
  readonly pq3: PqData | undefined;
  readonly qt: QtData | undefined;
  readonly qrs: QrsData | undefined;
}

export interface PqData {
  readonly interval: number;
  readonly heartRate: number;
}

export interface QtData {
  readonly interval: number;
  readonly heartRate: number;
}

export interface QrsData {
  readonly interval: number;
  readonly heartRate: number;
}
